import form from 'ngtemplate-loader!./template.tpl.html';
import dayPicker from 'ngtemplate-loader!./day.tpl.html';
import moment from 'moment';

import "./styles";

export const moduleName = 'RessieApp.calendar';
export const name = 'cal';

const DayPickerDecorator = ($delegate) => {
  $delegate[0].templateUrl = dayPicker;
  return $delegate;
};

function Decorate($provide) {
  try {
    $provide.constant('legacy', false);
    // Newer angular ui bootstrap
    $provide.decorator('uibDaypickerDirective', DayPickerDecorator);
  } catch (error) {
    // older angular ui bootstrap
    if (/\[\$injector:unpr\]/.test(error.message)) {
      $provide.constant('legacy', true);
      $provide.decorator('daypickerDirective', DayPickerDecorator);
    }
  }
}

class Calendar {

  /* @ngInject */
  constructor($scope, $filter, $timeout, $element, $animate, legacy) {
    const vm = this;
    this.$scope = $scope;
    this.$filter = $filter;
    this.$elm = $element;
    this.$timeout = $timeout;
    this.$animate = $animate;
    this.opened = false;
    this.oldDatePicker = legacy;

    this.dateOptions = {
      showWeeks: false,
      formatDay: "d",
      formatMont: "MM",
      formatYear: "yyyy"
    };

    this.$animate.on('addClass', $element, (elm, evtName, attrs) => {
      if(evtName === 'start' && attrs.addClass === 'open') {
        this.parent.style.height = `${this.initHeight + this.calHeight}px`;
      }
    });

    this.$animate.on('removeClass', $element, (elm, evtName, attrs) => {
      const classes = elm[0].classList;
      if(classes.contains('cal-bar') || (attrs.removeClass === 'invalid' && classes.contains('slide-calendar'))) {
        switch (evtName) {
          case 'start':
            elm.addClass('closing');
            $timeout(() => {
              this.parent.style.height = `${this.initHeight}px`;
            }, 250)
            break;
          case 'close':
            elm.removeClass('closing');
        }
      }
    });
  }

  print(format) {
    if(this.date) return moment.utc(this.date).format(format);
    return undefined;
  }

  get form() {
    return this.$scope[this.name];
  }

  get isOpen() {
    return this.opened;
  }

  toggle() {
    this.opened = !this.opened;
  }

  get date() {
    return this.selectedDate;
  }

  set date(date) {
    this.selectedDate = date;
  }

  $onInit() {
    this.$timeout(() => {
      this.parent = this.$elm[0].querySelector('.cal-bar');
      this.button = this.parent.querySelector('.slide-calendar');
      this.width = this.button.offsetWidth;
      this.initHeight = this.button.offsetHeight;
      this.calHeight = this.parent.querySelector('.calendar').offsetHeight;
      this.parent.style.height = `${this.initHeight}px`;
    });
  }

}

export default (MODULE) => {
  angular.module(MODULE)
    .config(Decorate)
    .component(name, {
      bindings: {
        selectedDate: '=',
        ngRequired: '=',
        name: '@'
      },
      templateUrl: form,
      controller: Calendar
    });
  return name;
};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/calendar/index.js